import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=5b459b8a&scoped=true&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=5b459b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b459b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b459b8a')) {
      api.createRecord('5b459b8a', component.options)
    } else {
      api.reload('5b459b8a', component.options)
    }
    module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=5b459b8a&scoped=true&", function () {
      api.rerender('5b459b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/main/LanguageSwitcher.vue"
export default component.exports